import Vue from 'vue'

// 날짜, 시간
Vue.filter('ymdPoint', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1. $2. $3') : '미등록' }) // YYYY. MM. DD
Vue.filter('ymdPointEmpty', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1. $2. $3') : '' }) // YYYY. MM. DD
Vue.filter('ymdPointNoSpace', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1.$2.$3') : '미등록' }) // YYYY. MM. DD
Vue.filter('ymdHyphen', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1-$2-$3') : '미등록' }) // YYYY-MM-DD
Vue.filter('ymdKor', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1년 $2월 $3일') : '미등록' }) // YYYY년 MM월 DD일
Vue.filter('ymdKorNoSpace', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1년$2월$3일') : '미등록' }) // YYYY년 MM월 DD일
Vue.filter('ymdSlash', (val) => { return val ? val.replace(/(^\d{4})(\d+)(\d{2})/g, '$1/$2/$3') : '미등록' }) // YYYY/MM/DD
Vue.filter('ymPoint', (val) => { return val ? val.replace(/(^\d{4})(\d+)/g, '$1. $2') : '미등록' }) // YYYY. MM
Vue.filter('ymHyphen', (val) => { return val ? val.replace(/(^\d{4})(\d+)/g, '$1-$2') : '미등록' }) // YYYY-MM
Vue.filter('twoYmd', (val) => {
        if (val) {
            let yy = val.substr(2, 2)
            let mm = val.substr(4, 2)
            let dd = val.substr(6, 2)
            return yy + mm + dd
        } else {
            return '미등록'
        }
    }) // YYMMDD
Vue.filter('twoYmdPoint', (val) => {
        if (val) {
            let yy = val.substr(2, 2)
            let mm = val.substr(4, 2)
            let dd = val.substr(6, 2)
            return `${yy}.${mm}.${dd}`
        } else {
            return '미등록'
        }
    }) // YY.MM.DD
Vue.filter('noYmmddKor', (val) => {
    if (val) {
        let mm = val.substr(4, 2)
        let dd = val.substr(6, 2)
        return mm + ' 월' + dd + ' 일'
    } else {
        return '미등록'
    }
})
Vue.filter('noYmmdd', (val) => {
    if (val) {
        let mm = val.substr(4, 2)
        let dd = val.substr(6, 2)
        return mm + '.' + dd
    } else {
        return '미등록'
    }
})
Vue.filter('dd', (val) => {
    if (val) {
        let dd = val.substr(6, 2)
        return dd
    } else {
        return '미등록'
    }
})
Vue.filter('ymdMonth', (val) => {
        if (val) {
            let mm = val.substr(4, 2)
            return mm + '월'
        }
    }) // MM월
Vue.filter('noDDYmKor', (val) => {
    if (val) {
        let yyyy = val.substr(0, 4)
        let mm = val.substr(4, 2)

        return yyyy + ' 년 ' + mm + ' 월'
    } else {
        return '미등록'
    }
})
Vue.filter('ymKor', (val) => { return val ? val.replace(/(^\d{4})(\d+)/g, '$1년 $2월') : '미등록' }) // YYYY년 MM월
Vue.filter('setTime', (val) => { return val ? val.replace(/(^\d{2})(\d+)/g, '$1:$2') : '미등록' }) // HH:MM
Vue.filter('setTimeKor', (val) => { return val ? val.replace(/(^\d{2})(\d+)/g, '$1시 $2분') : '미등록' }) // HH시 MM분
Vue.filter('ymdHms', (val) => {
    if (val) {
        let ymd = val.substr(0, 8)
        let hh = val.substr(8, 2)
        let mm = val.substr(10, 2)
        return ymd.replace(/(^\d{4})(\d+)(\d{2})/g, '$1. $2. $3') + ' ' + hh + ':' + mm
    }
})
Vue.filter('ymdHmsNoSpace', (val) => {
    if (val) {
        let ymd = val.substr(0, 8)
        let hh = val.substr(8, 2)
        let mm = val.substr(10, 2)
        return ymd.replace(/(^\d{4})(\d+)(\d{2})/g, '$1.$2.$3') + ' ' + hh + ':' + mm
    }
})
Vue.filter('Hm', (val) => {
    if (val) {
        let hh = val.substr(8, 2)
        let mm = val.substr(10, 2)
        return hh + ':' + mm
    }
})
Vue.filter('Hms', (val) => {
    if (val) {
        let ymd = val.substr(0, 8)
        let hh = val.substr(8, 2)
        let mm = val.substr(10, 2)
        let ss = val.substr(12, 2)
        return hh + ':' + mm + ':' + ss
    }
})
Vue.filter('createYmd', (val) => {
    if (val) {
        let yyyy = val.substr(0, 4)
        let mm = val.substr(4, 2)
        let dd = val.substr(6, 2)
        return yyyy + '. ' + mm + '. ' + dd
    }
})
Vue.filter('createYmdHyphen', (val) => {
    if (val) {
        let yyyy = val.substr(0, 4)
        let mm = val.substr(4, 2)
        let dd = val.substr(6, 2)
        return yyyy + '-' + mm + '-' + dd
    }
})
Vue.filter('createYmdKor', (val) => {
    if (val) {
        let yyyy = val.substr(0, 4)
        let mm = val.substr(4, 2)
        let dd = val.substr(6, 2)
        return yyyy + '년 ' + mm + '월 ' + dd + '일'
    }
})
Vue.filter('createHms', (val) => {
    if (val) {
        let hh = val.substr(8, 2)
        let mm = val.substr(10, 2)
        return hh + ':' + mm
    }
})
Vue.filter('createHmsMark', (val) => {
    if (val) {
        let hh = val.substr(0, 2)
        let mm = val.substr(2, 2)
        let ss = val.substr(4, 2)

        return `${hh}:${mm}:${ss}`
    } else {
        return '미등록(시간)'
    }
})
Vue.filter('createHmsMarkKor', (val) => {
    if (val) {
        let hh = val.substr(0, 2)
        let mm = val.substr(2, 2)
        let ss = val.substr(4, 2)

        return `${hh}시 ${mm}분 ${ss}초`
    } else {
        return '미등록(시간)'
    }
})
Vue.filter('createHmMark', (val) => {
    if (val) {
        let hh = val.substr(0, 2)
        let mm = val.substr(2, 2)

        return `${hh}:${mm}`
    } else {
        return '미등록(시간)'
    }
})
Vue.filter('createHmMarkKor', (val) => {
    if (val) {
        let hh = val.substr(0, 2)
        let mm = val.substr(2, 2)

        return `${hh}시 ${mm}분`
    } else {
        return '미등록(시간)'
    }
})
Vue.filter('month', (val) => { return val ? val.substr(4, 2) : '미등록' })

// 개인정보
Vue.filter('setMobileEmpty', (val) => { return val ? val.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/g, "$1-$2-$3") : '' })
Vue.filter('setMobile', (val) => { return val ? val.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/g, "$1-$2-$3") : '미등록(무선)' }) // 000-0000-0000
Vue.filter('setTel', (val) => { return val ? val.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/g, "$1-$2-$3") : '미등록(유선)' }) // 000-0000-0000
Vue.filter('setGender', (val) => { // 성별 남자,여자
    if (val) {
        return val === 'F' ? '여자' : '남자'
    } else {
        return '미등록(성별)'
    }
})
Vue.filter('setAge', (val) => { return val ? val + '세' : '생년월일 미등록' })
Vue.filter('setYn', (val) => { return val === 'Y' ? '있음' : '없음' })
Vue.filter('isEmpty', (val) => { return val ? val : '미등록' })
Vue.filter('isZero', (val) => { return val ? val : '0' })

//
Vue.filter('setMd', (val) => { return val.replace(/(^\d{4})(\d+)(\d{2})/g, '$2/$3') })
    // kb
Vue.filter('kb', (val) => { return val ? `${Math.floor(val/1024)} kb` : '' })

// 금액, 거리 등 숫자 ,추가
Vue.filter('setComma', (val) => { 
    // return val ? String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 
    // if(!val&&val!==0) return
    let front = val? String(val).substr(0,1):null
    if(front === '-') {
        return '-' + String(val).clearValue().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    } else {
        return val ? String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 
    }
})

// 4자리 숫자마다 공백 추가
Vue.filter('setCardNo', (val) => { return val ? String(val).replace(/\B(?=(\d{4})+(?!\d))/g, " ") : 0 })

// 글자수 
Vue.filter('setContent', (val, num) => { return val && val.length >= Number(num) ? `${val.substr(0,Number(num))}...` : val }) // 00자 이상이면 ...으로 처리 -> num을 받아서 몇자이상일때 ...처리할지 정해준다

// 특수문자제거
Vue.filter('rmSpecialCharacter', (val) => {
    return val && val.length >= 1 ? val.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi, "") : 0
})

// 가운데 이름 가리기
Vue.filter('setHideUserName', (val) => {
        let result

        if (val) {
            if (val.length > 2) {
                let ori = val.split('')
                ori.forEach((element, i) => {
                    if (i === 0 || i === (ori.length - 1)) return;
                    else ori[i] = 'O'
                });

                let joinName = ori.join()
                return joinName.replace(/,/g, '');
            } else {
                result = val.replace(/.$/, 'O');
                //result = val.replace(/(?<=.{1})./gi, '*')
            }
        } else {
            result = '미등록'
        }
        return result
    }) // 홍O동

// 생년월일 숨기기
Vue.filter('setHideBirthday', (val) => {
        return val ? val.substr(0, 4) + ' 년생' : '미등록(생년월일)'
    }) // 000-XXXX-0000

// 모바일 가운데 번호 감추기
Vue.filter('setHideMobile', (val) => { return val ? val.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/g, "$1-XXXX-$3") : '미등록(무선)' }) // 000-XXXX-0000


// WEBPACK FOOTER //
// ./src/utils/filters.js